export function generateColor() {
  const letters = "0123456789abcdef";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const generateLightColor = (): string => {
  const letters = "0123456789abcdef";
  let color = "#";

  for (let i = 0; i < 6; i++) {
    // Restrict the randomization to the latter half of the letters array to generate light colors
    color += letters[Math.floor(Math.random() * 8) + 8];
  }

  return color;
};

export const generateSeededLightColor = (seed: string): string => {
  const letters = "0123456789abcdef";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    // Restrict the randomization to the latter half of the letters array to generate light colors
    color += letters[(seed.charCodeAt(i) % 8) + 8];
  }
  return color;
};

export const brightenColor = (hexColor: string, factor = 0.1): string => {
  if (hexColor.startsWith("#")) {
    hexColor = hexColor.slice(1);
  }

  // Convert hex to RGB values
  let r = Number.parseInt(hexColor.substring(0, 2), 16);
  let g = Number.parseInt(hexColor.substring(2, 4), 16);
  let b = Number.parseInt(hexColor.substring(4, 6), 16);

  // Increase each RGB value by the factor, ensuring it doesn't exceed 255
  r = Math.min(255, Math.round(r + r * factor));
  g = Math.min(255, Math.round(g + g * factor));
  b = Math.min(255, Math.round(b + b * factor));

  // Convert RGB back to hex and return
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export const getContrastColor = (hexColor?: string): string => {
  if (!hexColor) return "#000000ff";

  if (hexColor.startsWith("#")) {
    hexColor = hexColor.slice(1);
  }

  // Convert hex to RGB values
  const r = Number.parseInt(hexColor.substring(0, 2), 16) / 255;
  const g = Number.parseInt(hexColor.substring(2, 4), 16) / 255;
  const b = Number.parseInt(hexColor.substring(4, 6), 16) / 255;

  // Calculate the luminance of the color
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // Return either black or white based on the luminance
  return luminance > 0.4 ? "#000000bb" : "#ffffffff";
};
